/*
* Pipeline Theme — East at Main
*
* Custom Javascript
*/
 
(function() {
 
  function initSwatchHover() {
    document.querySelectorAll('radio-swatch').forEach(function(swatch) {
      swatch.addEventListener('mouseenter', function() {
        var input = this.querySelector('input[type="radio"]');
        if (input) {
          input.click();
        }
      });
    });
  }
 
  // Run on page load
  document.addEventListener('DOMContentLoaded', initSwatchHover);
 
  // Re-run if swatches are re-rendered (quick view, section reload, etc.)
  document.addEventListener('theme:section:load', initSwatchHover);
 
})();